import _ from 'lodash'
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import {
  Navbar,
  NavItem,
} from 'reactstrap'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import SearchBar from '../components/SearchBar'
import IconMenu from '../images/icon_menu.svg'
import IconSearch from '../images/icon_search.svg'
import IconCart from '../images/icon_cart.svg'
import IconOrders from '../images/icon_orders.svg'
import ChanelLogoBlack from '../images/chanel-logo-black.svg'
import DrawerMenu from '../containers/DrawerMenu'
import I18n from '../lib/i18n'
import * as API from '../api'
import * as StyledComponent from '../styles'
import * as ScrollViewControl from '../lib/scrollViewControl'

class HeaderBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      is_drawer_open: false,
      departments: [],
      is_nav_bar_toggled: true
    }
  }

  componentDidMount() {
    this.getDepartmentsAndCategories()
  }

  toggleDrawer = () => {
    const is_drawer_open = !!!this.state.is_drawer_open

    is_drawer_open
      ? ScrollViewControl.preventScrolling()
      : ScrollViewControl.allowScrolling()

    this.setState({ is_drawer_open })
  }

  toggleSearchBar = () => {
    const is_search_bar_toggled = !!!this.props.store.is_search_bar_toggled
    this.saveToStore({ is_search_bar_toggled })
  }

  toggleNavbar = () => {
    const is_nav_bar_toggled = !!!this.state.is_nav_bar_toggled
    this.setState({ is_nav_bar_toggled })
  }

  submitSearch = (value) => {
    this.toggleSearchBar()
    this.props.history.push(`/${I18n.currentLocale()}/search?q=${value}`)
  }

  getDepartmentsAndCategories = () => {
    const system_settings = _.get(this.props, 'store.system_settings', {})
    const query_params = system_settings['api.v2.departments.index.menu.cdb.query']

    API.fetchDepartmentsWithCategory(query_params).then(res => {
      const departments = _.get(res, 'data.departments')
      this.setState({ departments })
    })
  }

  closeInfoForm = () => {
    this.saveToStore({ is_info_form_open: false })
  }

  saveToStore = (state, cb) => {
    this.props.store.save(state, cb)
  }

  render() {
    const { cart_total_items = 0, is_search_bar_toggled } = this.props.store
    const { departments, is_drawer_open, is_nav_bar_toggled } = this.state
    const cart_dot_class = cart_total_items > 0 ? 'dot' : ''
    const no_completed_orders = _.isEmpty(API.getStorage('completed_orders'))
    const orders_dot_class = !no_completed_orders ? 'dot' : ''
    const hide_buttons = _.includes(this.props.location.pathname, 'order_history') || _.includes(this.props.location.pathname, 'thank_you')
    const hide_button_class = hide_buttons ? 'hidden' : ''

    return <StyledComponent.HeaderBar>
      {
        is_nav_bar_toggled &&
          <Navbar light>
            <NavItem
              className={`header-icon header-icon--menu ${hide_button_class}`}
              onClick={this.toggleDrawer}
            >
              <img src={IconMenu} alt={I18n.t('header_menu.menu')} />
            </NavItem>
            <NavItem
              className={`header-icon header-icon--search ${hide_button_class}`}
              onClick={this.toggleSearchBar}
            >
              <img src={IconSearch} alt={I18n.t('header_menu.search')} />
            </NavItem>
            <div className='navbar-brand'>
            {
              hide_buttons
                ? <img alt='' src={ChanelLogoBlack} />
                : <NavLink to={'/'+ I18n.currentLocale() +'/products/'}>
                    <img alt='' src={ChanelLogoBlack} />
                  </NavLink>
            }
            </div>
            <NavItem className={`header-icon header-icon--qr ${hide_button_class} ${orders_dot_class}`}>
              {
                no_completed_orders
                  ? <img src={IconOrders} alt={I18n.t('header_menu.my_qr')} />
                  : <NavLink activeClassName="active" to={'/'+ I18n.currentLocale() +'/order_history/'}>
                      <img src={IconOrders} alt={I18n.t('header_menu.my_qr')} />
                    </NavLink>
              }
            </NavItem>
            <NavItem className={`header-icon header-icon--cart ${hide_button_class} ${cart_dot_class}`} >
              <NavLink activeClassName="active" to={'/'+ I18n.currentLocale()} onClick={this.closeInfoForm}>
                <img src={IconCart} alt={I18n.t('header_menu.cart')}/>
                <span className="d-none">{I18n.t('header_menu.cart')}</span>
              </NavLink>
            </NavItem>
          </Navbar>
      }
      <CSSTransition
        in={is_search_bar_toggled}
        classNames='fade-search-bar'
        timeout={200}
        unmountOnExit
        onEnter={this.toggleNavbar}
        onExited={this.toggleNavbar}
      >
        <SearchBar
          onChange={() => {}}
          onSearch={this.submitSearch}
          onClear={() => {}}
          onCancel={this.toggleSearchBar}
          border='bottom'
        />
      </CSSTransition>
      {
        !hide_buttons &&
          <DrawerMenu
            open={is_drawer_open}
            departments={departments}
            toggleDrawer={this.toggleDrawer}
          />
      }
    </StyledComponent.HeaderBar>
  }
}

export default HeaderBar



// WEBPACK FOOTER //
// ./src/components/HeaderBar.js